import { Button, DismissIcon, Flex, Link } from '@iheartjane/reefer';
import { useState } from 'react';

import type { SelectedItem } from './util/conditionSelection.util';

const VISIBLE_LIMIT = 10;

export interface ConditionTagListProps {
  disabled?: boolean;

  items: SelectedItem[];

  /** Names the overflow toggle */
  label: string;

  onRemove(value: string): void;
}

/** A section row's selections, renders nothing when nothing is selected */
export const ConditionTagList = ({
  disabled,
  items,
  label,
  onRemove,
}: ConditionTagListProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (items.length === 0) {
    return null;
  }

  const visibleItems = isExpanded ? items : items.slice(0, VISIBLE_LIMIT);
  const hasOverflow = items.length > VISIBLE_LIMIT;

  return (
    <Flex alignItems="center" flexDirection="column">
      <Flex as="ul" flexWrap="wrap" gap={8} pb={8} width="100%">
        {visibleItems.map((item) => (
          <li key={item.value}>
            <Button
              label={item.label}
              ariaLabel={`Remove ${item.label}`}
              disabled={disabled}
              endIcon={<DismissIcon size="sm" color="inherit" />}
              onClick={() => onRemove(item.value)}
              variant="secondary"
            />
          </li>
        ))}
      </Flex>
      {hasOverflow && (
        <Link onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded
            ? 'View less'
            : `View all ${items.length} ${label.toLowerCase()}`}
        </Link>
      )}
    </Flex>
  );
};
